module.exports = __webpack_public_path__ + "img/nogrp_1a.25fb0652.svg";